import React, { Component } from 'react'
import * as Cookies from "es-cookie";
import { isBrowser } from "react-device-detect";
import NavbarOne from '../components/navbars/NavbarOne'
import SideNavbar from '../components/navbars/SideNavbar'
import OverallReportsCollege from '../components/overallCollegeReport/OverallReportsCollege'

class OverallCollegeReport extends Component {

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        const next = toggled === "wrapper" ? "wrapper sidebar-enable" : "wrapper";
        this.setState({ toggled: next });
        Cookies.set("toggle", next);
    };

    render() {
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>

                <div className="main-wrapper">
                    <div
                        id="sidebar"
                        className={
                            isBrowser
                                ? "sidebar-menu d-none d-xl-block d-lg-block"
                                : "sidebar-menu d-block d-xl-none d-lg-none"
                        }
                    >
                        <SideNavbar onClick={this.menuToggler} />
                    </div>

                    <OverallReportsCollege />
                </div>
            </div>
        );
    }
}

export default OverallCollegeReport
